import styled from "styled-components";

export const ContentStyled = styled.div`
  flex: 1;
`;
